import { Box, Tooltip as MuiTooltip, type SxProps, type Theme, type TooltipProps } from '@mui/material'

interface Props {
  title?: React.ReactNode
  placement?: TooltipProps['placement']
  compact?: boolean
  fullWidth?: boolean
  children: React.ReactNode
}

export function Tooltip({ title, placement = 'top', compact, fullWidth, children }: Props) {
  const sxConfig: SxProps<Theme> = compact
    ? {
        maxWidth: 200,
        whiteSpace: 'pre-line',
        fontSize: '12px',
        padding: '4px 8px',
        bgcolor: 'grey.900',
        color: 'primary.contrastText',
      }
    : {
        maxWidth: 350,
        whiteSpace: 'pre-line',
      }
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      enterDelay={compact ? 750 : 0}
      enterNextDelay={compact ? 750 : 0}
      arrow={!compact}
      slotProps={{ tooltip: { sx: sxConfig } }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{
          pointerEvents: 'auto',
          cursor: title ? 'help' : 'inherit',
          ...(fullWidth && { flex: 1, minWidth: 0 }),
        }}
      >
        {children}
      </Box>
    </MuiTooltip>
  )
}
